import actions from './actions'
import * as types  from './types'
import getters from './getters'

const state = {
  isOptimizing: false,
  schedule: null,
  optimizedSchedule: null,
  optimizedDrops: null,
  isSaving: false,
  isReadyToBeSaved: false,
}
const initialState = {
  isOptimizing: false,
  schedule: null,
  optimizedDrops: null,
  isSaving: false,
  isReadyToBeSaved: false,
}

const mutations = {
  [types.SET_SCHEDULE](state, action) {
    state.schedule = action.schedule
  },
  [types.SET_IS_OPTIMIZING](state, action) {
    state.isOptimizing = action.flag
  },
  [types.SET_IS_SAVING](state, action) {
    state.isSaving = action.flag
  },
  [types.SET_IS_READY_TO_BE_SAVED](state, action) {
    state.isReadyToBeSaved = action.flag
  },
  [types.SET_OPTIMIZED_DROPS](state, action) {
    state.optimizedDrops = action.drops
  },
  [types.SET_RESET_STATE] (state, action) {
    Object.assign(state, initialState)
  }
}

export const shipmentsSchedule = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
